import { Entity } from '../base/entity';
import { SpecifikacijaItem } from './specifikacija-item';
import { isNil } from 'lodash';
import { durationSecondsToString, durationStringToSeconds } from 'app/helpers/duration-helpers';

export class Specifikacija extends Entity {

  public static readonly TABLENAME = 'specifikacija';

  public static readonly ID = 'id';
  public static readonly NAZIV = 'naziv';
  public static readonly OPIS = 'opis';
  public static readonly UNIT_ID = 'unit_id';
  public static readonly DURATION = 'duration';

  id: number;
  naziv: string;
  opis: string;
  unitId: string;
  duration: number;


  items: SpecifikacijaItem[];

  constructor(jsonObj: any) {
    super(jsonObj);

    if (!isNil(jsonObj)) {
      if (!isNil(jsonObj.items)) {
        this.items = jsonObj.items.map((it: any) => new SpecifikacijaItem(it));
      } else {
        this.items = [];
      }
    }
  }

  // GETTER -> sekunde u "HH:mm"
  get durationAsString(): string {
    return durationSecondsToString(this.duration);
  }

  // SETTER -> "HH:mm" u sekunde
  set durationAsString(value: string) {
    this.duration = durationStringToSeconds(value);
  }
}
